import RootNavigationContainer from '@routes/containers/RootNavigationContainer';
import rootReducer from '@store/rootReducer';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { createStore } from 'redux';
import '@coreui/coreui/dist/css/coreui.min.css';
import '@styles/core.css';

const store = createStore(rootReducer, undefined);

store.dispatch({ type: '@@INIT', payload: {} });

const App = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <RootNavigationContainer />
      </BrowserRouter>
    </Provider>
  );
};

export default App;
